import * as React from 'react';

import { SocialsItem } from '../../../../interfaces';

import { socialsConfig } from './socialsLinks.configs';
import { Container, SocialButton, SocialIcon, SocialLabel } from './socialsLinks.styled';
import { SocialsLinksProps } from './socialsLinks.types';

export const SocialsLinks: React.FC<SocialsLinksProps> = (props: SocialsLinksProps) => {
  const { items, className }: SocialsLinksProps = props;

  return (
    <Container className={className}>
      {items.map((item: SocialsItem) => (
        <SocialButton href={item.url} target='_blank' key={item.url}>
          <SocialIcon src={socialsConfig[item.type].file} alt={socialsConfig[item.type].alt} />
          <SocialLabel>{socialsConfig[item.type]?.label}</SocialLabel>
        </SocialButton>
      ))}
    </Container>
  );
};
